import { Box } from '@mui/material'
import loginImage from 'assets/meet-the-team.svg'
import WrapperPermission from 'components/wrapper-permission'
import { useCustomTheme } from 'contexts/theme'
import React, { useEffect, useState } from 'react'
import { useStyles } from './styles'

const EmailCheck: React.FC = () => {
  const [email, setEmail] = useState('')
  const { theme } = useCustomTheme()
  const classes = useStyles()

  // initial load

  useEffect(() => {
    async function loadData() {
      const transferData = localStorage.getItem('conducco')

      if (transferData) {
        const jsonData = JSON.parse(transferData)

        setEmail(jsonData.email)
      }
    }

    loadData()
  }, [])

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.leftBox}>
            <h1 className={classes.insideH1}>Falta pouco para criar a sua conta na Conducco</h1>
            <p>
              Conducco criou o Cofre Digital, para dar controle às empresas na troca de dados corporativos de forma mais
              segura e conveniente, aderente às normas previstas na LGPD.
            </p>
            <p>
              A Conducco é construída sob tecnologias de governança de dados de nível mundial: Snowflake e Amazon Web
              Services.
            </p>
            <p>
              Saiba mais sobre nossas <a href='#'>Política de Dados.</a>
            </p>
            <Box className={classes.loginImage}>
              <img
                src={loginImage}
                alt='Login'
              />
            </Box>
          </Box>
        </WrapperPermission>
        <Box className={classes.rightWrapper}>
          <Box
            component='form'
            noValidate
            data-testid='form'
            className={classes.formBox}
          >
            <img
              src={theme.name === 'custom' ? theme.logo.base : `/${theme.name}/logo.svg`}
              className={classes.logoImage}
              alt='Logo'
            />

            <div className={classes.greenBox}>Email de confirmação enviado para {email}</div>

            <div className={classes.checkEmailHeader}>Verifique Seu Endereço de Email</div>

            <div className={classes.checkEmailBody}>
              Nós enviamos um email para que você confirme seu email. Clique no link enviado para finalizar o processo
              de cadastro. Por favor, entre em contato se você não receber o email em alguns minutos.
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmailCheck
